import React from 'react'
import { StyledIcon } from '../StyledIcon'

const PrinterIcon = ({ icon, size, customProps }) => (
  <StyledIcon
    viewBox="0 0 485.212 485.212"
    a11yTitle={icon}
    color="plain"
    size={size}
    {...customProps}
  >
    <g>
      <rect x="151.636" y="363.906" width="151.618" height="30.331" />
      <path
        d="M121.312,30.327h242.595v60.651h30.321V30.327C394.229,13.595,380.666,0,363.907,0H121.312
  c-16.748,0-30.327,13.595-30.327,30.327v60.651h30.327V30.327z"
      />
      <rect x="151.636" y="303.257" width="181.939" height="30.327" />
      <path
        d="M454.882,121.304H30.334c-16.748,0-30.327,13.591-30.327,30.324v181.956c0,16.759,13.579,30.321,30.327,30.321h60.651
  v90.98c0,16.764,13.579,30.326,30.327,30.326h242.595c16.759,0,30.321-13.562,30.321-30.326v-90.98h60.653
  c16.76,0,30.322-13.562,30.322-30.321V151.628C485.204,134.895,471.642,121.304,454.882,121.304z M363.907,454.886H121.312V272.93
  h242.595V454.886z M424.551,212.282c-16.76,0-30.322-13.564-30.322-30.327c0-16.731,13.562-30.327,30.322-30.327
  c16.765,0,30.331,13.595,30.331,30.327C454.882,198.717,441.315,212.282,424.551,212.282z"
      />
    </g>
  </StyledIcon>
)

export default PrinterIcon
